export const SET_USERS = "SET_USERS";
export const SET_USER = "SET_USER";
export const SET_ROLES = "SET_ROLES";
export const SET_PERMISSIONS = "SET_PERMISSIONS";
